/*
 * Copyright (C) 2022 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import { handleActions } from 'redux-actions';
export default handleActions({
  INITIAL_OPTIONS: (state, action) => {
    var _action$payload$obser;

    return action.payload.observedUserId || ((_action$payload$obser = action.payload.observedUser) === null || _action$payload$obser === void 0 ? void 0 : _action$payload$obser.id) || null;
  },
  SELECTED_OBSERVEE: (state, action) => {
    return action.payload || null;
  }
}, null);